export const verifyEvent = (event) => {
  if (!event) {
    console.error("No event to parse");
    return false;
  }
  const { id, pubkey, created_at, kind, tags, sig, content } = event;
  if (!(id && pubkey && created_at && kind && tags && sig)) {
    console.error("Invalid event structure");
    return false;
  }
  let identifier = "";
  let type = "basic";
  let icon = "";
  let image = "";
  let input = "";
  let buttons = [];

  for (let tag of tags) {
    if (tag[0] === "d") identifier = tag[1];
    if (tag[0] === "l") type = tag[1];
    if (tag[0] === "icon") icon = tag[1];
    if (tag[0] === "image") image = tag[1];
    if (tag[0] === "input") input = tag[1];
    if (tag[0] === "button") {
      let button_ = {
        label: tag[1],
        type: tag[2],
        url: tag[3],
      };
      buttons.push(button_);
    }
  }
  let aTag = `${kind}:${pubkey}:${identifier}`;
  return {
    id,
    type,
    icon,
    content,
    pubkey,
    kind,
    image,
    input,
    buttons,
    identifier,
    aTag,
  };
};
